import moment from 'moment'
import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index'

// initial state
const state = () => ({
  trend: [],
  perPage_Temperature: 5,
  pageOptions_Temperature: [3, 5, 10],
  totalRows_Temperature: 1,
  sortOptions_Temperature: [],
  fields_Temperature: [
    { key: 'datetime', label: 'datetime', sortable: true },
    { key: 'value', label: 'value' },
  ],
  perPage_Battery: 5,
  pageOptions_Battery: [3, 5, 10],
  totalRows_Battery: 1,
  sortOptions_Battery: [],
  fields_Battery: [
    { key: 'datetime', label: 'datetime', sortable: true },
    { key: 'value', label: 'value' },
  ],
  historical_sparing_houly: [],
  historical_sparing: [],
  historical_battery_houly: [],
  historical_battery: [],
  deviceoptions: [],
  deviceList: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    totalActive: 1,
    totalOffline: 1,
    totalError: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: false },
      { key: 'area_name', label: 'Area', sortable: true },
      { key: 'location_name', label: 'location', sortable: true },
      { key: 'site_name', label: 'Site', sortable: true },
      { key: 'device_name', label: 'device', sortable: true },
      { key: 'device_value', label: 'Value', sortable: false },
      { key: 'device_type_name', label: 'Type', sortable: true },
      { key: 'device_status', label: 'Status', sortable: false },
    ],
    items: [],
  },
  inventory: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'id', label: 'id', sortable: true },
      { key: 'name', label: 'name', sortable: true },
      { key: 'area_name', label: 'area name', sortable: true },
      { key: 'location_name', label: 'location name', sortable: true },
      { key: 'device_sum', label: 'device sum', sortable: true },
      { key: 'device_sum_active', label: 'device sum active', sortable: true },
      {
        key: 'device_sum_deactive',
        label: 'device sum deactive',
        sortable: true,
      },
      { key: 'description', label: 'description', sortable: true },
    ],
    items: [],
  },
  report: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'area_name', label: 'area name', sortable: true },
      { key: 'device_code', label: 'device code', sortable: true },
      {
        key: 'device_installation_date',
        label: 'device installation date',
        sortable: true,
      },
      { key: 'device_msisdn', label: 'device msisdn', sortable: true },
      { key: 'device_name', label: 'device name', sortable: true },
      {
        key: 'device_serial_number',
        label: 'device serial number',
        sortable: true,
      },
      { key: 'device_status', label: 'device status', sortable: true },
      { key: 'device_type_name', label: 'device type name', sortable: true },
      { key: 'district_name', label: 'district name', sortable: true },
      { key: 'location_name', label: 'location name', sortable: true },
      { key: 'site_name', label: 'site name', sortable: true },
    ],
    items: [],
  },
  device_list: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'site_name', label: 'Site Name', sortable: true },
      { key: 'device_code', label: 'Device Code', sortable: true },
      { key: 'device_value', label: 'Value', sortable: true },
      { key: 'device_status', label: 'Status', sortable: true },
    ],
    items: [],
  },
  dashboard: { sparing: [], items: [] },
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/sparing/device/trend?device_id=${params.device_id}&mode=${params.status}&date_start=${params.datestart}%2017:00:00&date_finish=${params.datefinish}%2017:00:00`,
      }
      useIPA.getInternal(param).then(response => {
        const sparing = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setData', { ...sparing })
      })
    })
  },
  getAllSparing({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/sparing/device/trend?device_id=${params.device_id}&mode=${params.status}&date_start=${params.datestart}%2017:00:00&date_finish=${params.datefinish}%2017:00:00`,
      }
      useIPA.getInternal(param).then(response => {
        const sparing = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDataSparing', { ...sparing })
      })
    })
  },
  getDashboard({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/dashboard/sparing?latitude=-6.260455&longitude=106.972716&province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=${params.district_id}`,
      }
      useIPA.getInternal(param).then(response => {
        const sparing = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDashboard', { ...sparing })
      })
    })
  },
  getDashboardSparing({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/dashboard/sparing?latitude=-6.260455&longitude=106.972716&province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=${params.district_id}`,
      }
      useIPA.getInternal(param).then(response => {
        const sparing = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDashboardSparing', { ...sparing })
      })
    })
  },
  getDeviceList({ commit }, params) {
    const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
    const param = {
      status: `internal/master/devices/list?province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=${params.district_id}&site_id=${params.site_id}&status=${params.status}&page=${params.page}&limit=${params.limit}${orderBy}`,
    }
    useIPA.getInternal(param).then(response => {
      const DeviceList = {
        rows: response.data,
      }
      commit('setDeviceList', { ...DeviceList })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('device_id', formData.select_1)
      rawData.set('latitude', formData.text_3)
      rawData.set('longitude', formData.text_4)
      rawData.set('installator_company', formData.text_1)
      rawData.set('installator_name', formData.text_2)
      rawData.set(
        'installation_date',
        moment(formData.date_1.split(' '), 'YYYY-MM-DD').format('YYYY-MM-DD'),
      )
      rawData.set('site_id', formData.select_9)
      rawData.set('update_interval', formData.text_5)
      if (formData.setUpload === 'upload') {
        rawData.append('file_documentation', formData.instalasi)
      } else {
        rawData.set('file_documentation', formData.instalasi)
      }
      if (formData.setUpload2 === 'upload') {
        rawData.append('file_bast', formData.bast)
      } else {
        rawData.set('file_bast', formData.bast)
      }
      if (formData.setUpload3 === 'upload') {
        rawData.append('file_calibration', formData.kalibrasi)
      } else {
        rawData.set('file_calibration', formData.kalibrasi)
      }
      const param = {
        rawData,
        url: 'internal/sparing/device/installation',
        id: formData.id,
      }
      useIPA.postput(param).then(
        response => {
          router.push({ name: 'sparing-device' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        },
      )
    })
  },
  getByIdInstall({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `sparing/device/detail?device_id=${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data[0])
      })
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device/type/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  getDeviceInstall({ commit }, id) {
    const param = {
      status: 'internal/sparing/data/master/device/installed?site_id=',
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setDeviceInstall', { ...Data })
    })
  },
  getDeviceInstallSparing({ commit }, id) {
    const param = {
      status: 'internal/sparing/data/master/device/installed?site_id=',
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setDeviceInstall', { ...Data })
    })
  },
  getInventory({ commit }, params) {
    const param = {
      status: `internal/sparing/device/inventory/list?province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setInventory', { ...Data })
    })
  },
  getReport({ commit }, params) {
    const param = {
      status: `internal/sparing/device/report/list?province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=&date_start=${params.date_start}&date_finish=${params.date_start}`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setReport', { ...Data })
    })
  },
}

// mutations
const mutations = {
  setData(state, sparing) {
    state.trend = sparing.rows
    state.historical_sparing = sparing.rows.historical_sparing
    state.historical_sparing = sparing.rows.historical_sparing
    state.totalRows_Temperature = sparing.rows.historical_sparing.length
    state.historical_battery = sparing.rows.historical_battery
    state.historical_battery = sparing.rows.historical_battery
    state.totalRows_battery = sparing.rows.historical_battery.length
  },
  setDataSparing(state, sparing) {
    state.trend = sparing.rows
    state.historical_sparing = sparing.rows.historical_sparing
    state.historical_sparing = sparing.rows.historical_sparing
    state.totalRows_Temperature = sparing.rows.historical_sparing.length
    state.historical_battery = sparing.rows.historical_battery
    state.historical_battery = sparing.rows.historical_battery
    state.totalRows_battery = sparing.rows.historical_battery.length
  },
  setDeviceList(state, DeviceList) {
    DeviceList.rows.data.forEach((element, index) => {
      element.no = index + 1
    })
    state.deviceList.items = DeviceList.rows.data
    state.deviceList.totalRows = DeviceList.rows.pagination.total_items

    state.deviceList.totalActive = DeviceList.rows.data.filter(
      f => f.device_status == 'IN',
    ).length
    state.deviceList.totalOffline = DeviceList.rows.data.filter(
      f => f.device_status == 'ER',
    ).length
    state.deviceList.totalError = DeviceList.rows.data.filter(
      f => f.device_status == 'FL',
    ).length
  },
  setDeviceInstall(state, data) {
    for (let i = 0; i < data.rows.length; i++) {
      const option = []
      for (const key in data.rows[i]) {
        if (key === 'device_id') {
          option.value = data.rows[i][key]
        } else if (key === 'device_name') {
          option.title = data.rows[i][key]
        } else if (key === 'device_id') {
          option.oid = data.rows[i][key]
        }
      }
      state.deviceoptions.push({ ...option })
    }
  },
  setDashboard(state, dashboard) {
    dashboard.rows.device_list.forEach((element, index) => {
      element.no = index + 1
    })
    state.device_list.items = dashboard.rows.device_list
    state.device_list.totalRows = dashboard.rows.device_list.length
    state.dashboard.items = dashboard.rows
  },
  setInventory(state, dashboard) {
    dashboard.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.inventory.items = dashboard.rows
    state.inventory.totalRows = dashboard.rows.length
  },
  setReport(state, dashboard) {
    dashboard.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.report.items = dashboard.rows
    state.report.totalRows = dashboard.rows.length
  },
  setDashboardSparing(state, dashboard) {
    state.dashboard.sparing = dashboard.rows
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
